import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { Edit } from "@mui/icons-material";
import ApiEndpoints from "../../network/ApiEndPoints";
import { ddmmyy } from "../../utils/DateUtils";
import AuthContext from "../../store/AuthContext";
import ApiPaginateSearch from "../../component/ApiPaginateSearch";
import CreateUInvoiceModal from "./CreateInvoiceModal";
import EditAssetModal from "./EditAssetModal";
import VisibilityIcon from '@mui/icons-material/Visibility';
import InvoiceViewModal from "./InvoiceViewModal";
import CachedIcon from "@mui/icons-material/Cached";
import EditInvoiceModal from "./EditInvoiceModal";
import DataFilter from "./Common/DataFilter";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteInvoiceModal from "./DeleteInvoiceModal";

let refresh;
function refreshFunc(setQueryParams) {
  if (refresh) refresh();
}
const Invoices = () => {
  const [apiData, setApiData] = useState([]);
  const [editAssetData, setEditAssetData] = useState(null);
  const [openEditModal, setOpenEditModal] = useState(false);
  const authCtx = useContext(AuthContext);
  const user = authCtx?.user;
const [selectedInvoice, setSelectedInvoice] = useState(null);
const [openInvoiceModal, setOpenInvoiceModal] = useState(false);
  const [query, setQuery] = useState();
const [editInvoiceModalOpen, setEditInvoiceModalOpen] = useState(false);
const [editInvoiceData, setEditInvoiceData] = useState(null);
const [deleteModalOpen, setDeleteModalOpen] = useState(false);
const [selectedInvoiceToDelete, setSelectedInvoiceToDelete] = useState(null);

const handleDeleteInvoice = (row) => {
  setSelectedInvoiceToDelete(row);
  setDeleteModalOpen(true);
};
const handleViewInvoice = (row) => {
  setSelectedInvoice(row);
  setOpenInvoiceModal(true);
};
const handleEditInvoice = (row) => {
  setEditInvoiceData(row);
  setEditInvoiceModalOpen(true);
};

  const columns = [
    {
      name: "Invoice No",
      selector: (row) => row.invoice_no,
    },
     ...(user?.role === "Admin"
    ? [
        {
          name: "Establishment",
          selector: (row) => row.establishment,
        },
      ]
    : []),
    {
      name: "Invoice Date",
      selector: (row) => ddmmyy(row.invoice_date),
    },
    {
      name: "Due Date",
      selector: (row) => ddmmyy(row.invoice_date), // assuming due date is same
    },
    ...(user?.role === "Admin"
    ? [
        {
          name: "Description",
      selector: (row) => row.description,
        },
      ]
    : []),
    
   ...(user?.role === "Admin"
    ? [
        {
          name: "Unit Price",
      selector: (row) => `₹${parseFloat(row.price).toFixed(2)}`,
        },
      ]
    : []),
   ...(user?.role === "Admin"
    ? [
        {
          name: "Total",
  selector: (row) =>
  `₹${parseFloat(row.amount).toFixed(2)}`    
       },
      ]
    : []),
  
    // {
    //   name: "Total",
    //   selector: (row) => {
    //     const total = parseFloat(row.amount);
    //     const taxAmount = (total * row.tax_rate) / 100;
    //     const grandTotal = total + taxAmount;
    //     return `₹${grandTotal.toFixed(2)}`;
    //   },
    // },
{
  name: "Actions",
  selector: (row) => (
    <Box sx={{ display: "flex", gap: 1 }}>
      <Tooltip title="View Invoice">
        <IconButton onClick={() => handleViewInvoice(row)}>
          <VisibilityIcon />
        </IconButton>
      </Tooltip>
      {user?.role === "Admin" && (
        <Tooltip title="Edit Invoice">
          <IconButton onClick={() => handleEditInvoice(row)} sx={{color:"blue"}}>
            <Edit />
          </IconButton>
        </Tooltip>
        
      )}
         <Tooltip title="Delete Invoice">
            <IconButton onClick={() => handleDeleteInvoice(row)} sx={{ color: "red" }}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
    </Box>
  ),
  width: "160px",
  ignoreRowClick: true,
  allowOverflow: true,
  button: true,
}

  ];

  return (
    <Grid sx={{ mt: 3 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "right",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 2,
          mb: 2,
        }}
      >
        {/* Left side */}
        <DataFilter handleRefresh={refreshFunc} />

        {/* Right side */}
        {user?.role !== "Admin" && (
          <CreateUInvoiceModal onSuccess={() => refresh && refresh()} />
        )}
      </Box>
      
      <ApiPaginateSearch
        apiEnd={ApiEndpoints.GET_INVOICES}
        columns={columns}
        apiData={apiData}
                    refresh={refresh}
          isFilterAllowed={true}
      
        setApiData={setApiData}
        queryParam=""
        returnRefetch={(ref) => {
          refresh = ref;
        }}
      />

      <EditAssetModal
        open={openEditModal}
        onClose={() => setOpenEditModal(false)}
        data={editAssetData}
        onSuccess={() => {
          setOpenEditModal(false);
          refresh && refresh();
        }}
      />
      <InvoiceViewModal
  open={openInvoiceModal}
  onClose={() => setOpenInvoiceModal(false)}
  invoice={selectedInvoice}
/>
<EditInvoiceModal
  open={editInvoiceModalOpen}
  onClose={() => setEditInvoiceModalOpen(false)}
  invoice={editInvoiceData}
  onSuccess={() => {
    setEditInvoiceModalOpen(false);
    refresh && refresh();
  }}
/>
<DeleteInvoiceModal
  open={deleteModalOpen}
  onClose={() => setDeleteModalOpen(false)}
  invoice={selectedInvoiceToDelete}
  onSuccess={() => {
    setDeleteModalOpen(false);
    refresh && refresh();
  }}
/>


    </Grid>
    
  );
};

export default Invoices;